module.exports = __webpack_public_path__ + "media/images/chart-839be0e06fbf23078803a3616feecf57.png";